<div *ngIf="busy">
  Please wait...
</div>

<div *ngIf="!busy">
  
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Filter: <input type="text" #filter />
  &nbsp;&nbsp;&nbsp;Ladder:
  <select [(ngModel)]="ladderId" (ngModelChange)="fetchPlayers($event)">
    <option *ngFor="let l of ladders" [value]="l.ladderId">{{l.name}} ({{l.ladderId}})</option>
  </select>
  &nbsp;&nbsp;&nbsp;<a href="#" (click)="clear($event)">Clear Impersonation</a>
  <table class="table">
    <tr *ngFor="let p of players | byname: filter.value">
      <td style="font-family:'Courier New', Courier, monospace"><a href="#" (click)=" impersonate($event, p.id)">{{p.id}}</a></td>
      <td>{{p.getFullName()}}</td>
    </tr>
  </table>



</div>